import DestinationFaq from './DestinationFaq.component';
export default DestinationFaq;